/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bills": {
        "nested": {
          "CurrencyExchange": {
            "fields": {
              "amountMoney": {
                "type": ".squareup.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "exchangeRate": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bills?.nested?.CurrencyExchange) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents currency exchange information for payments where one party's currency
 * differs from the other party currency (e.g., Bitcoin Lightning payments).
 * --
 *
 * SOURCE CurrencyExchange @ squareup/bills/currency_exchange.proto at 14:1
 */
export const CurrencyExchange = $root.lookupType('squareup.bills.CurrencyExchange');
fixType(CurrencyExchange);
Builder.createAndAttachToType(CurrencyExchange);